// src/components/ProjectDashboardGuide.js
import React from "react";
import { motion } from "framer-motion";
import "../App.css";
import backgroundVideo from '../assets/videos/dashboard-cover150.mp4'; 

function ProjectDashboardGuide() {
  const preventActions = (e) => e.preventDefault();

  return (
    <div className="guide-page" style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>

      {/* ======= الهيدر ======= */}
      <div className="guide-header">
        <video 
          autoPlay 
          muted 
          loop 
          playsInline 
          className="background-video"
          onContextMenu={preventActions}
        >
          <source src={backgroundVideo} type="video/mp4" />
          متصفحك لا يدعم تشغيل الفيديو.
        </video>

        <div className="guide-overlay">
          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            لوحة متابعة المشاريع
          </motion.h1>

          <motion.p
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
          >
            دليل استخدام وتثبيت النظام الخاص بمتابعة مشاريع العملاء
          </motion.p>
        </div>
      </div>

      {/* ======= قسم شرح التثبيت ======= */}
      <div className="guide-section">
        <h2>طريقة تثبيت النظام</h2>
        <p>
          تتيح لك لوحة متابعة المشاريع متابعة التقدم في مشروعك لحظة بلحظة.
          لإتمام التثبيت واستخدام النظام بنجاح، يُرجى اتباع الخطوات التالية:
        </p>

        <ul className="steps-list">
          <li>1- ادخل على الرابط المرسل إليك من الشركة.</li>
          <li>2- قم بتحميل البرنامج أو افتح النسخة السحابية.</li>
          <li>3- أدخل بيانات تسجيل الدخول الخاصة بك.</li>
          <li>4- بعد تسجيل الدخول ستظهر لك لوحة التحكم الرئيسية.</li>
          <li>5- يمكنك متابعة خطوات المشروع، عرض الرسومات، تنزيل الملفات وكل تفاصيل الأعمال.</li>
        </ul>
      </div>

      {/* ======= قسم الفيديو ======= */}
      <div className="guide-video-section">
        <h2>فيديو توضيحي</h2>
        <div className="video-frame">
          <iframe
            src="https://www.youtube.com/embed/H13Zuf5radw" 
            title="شرح النظام"
            allowFullScreen
          ></iframe>
        </div>
      </div>

    </div>
  );
}

export default ProjectDashboardGuide;